import {useEffect, useRef} from 'react';
import {Href} from '@sail/ui';
import {
  useWidgetControls,
  useWidgetVisibility,
  useWidget,
} from '../Widget/useWidget';
import {StripeAssistantHeader} from './StripeAssistantHeader';
import {ThemeProvider} from '../ThemeProvider';
import {DefaultTheme} from '../theme/theme';
import {LinkTheme} from '../theme/link';

type Props = {
  supportCenterHref?: Href;
  entryPoint?: string;
};

const getThemeForAudience = (entryPoint: string | undefined) => {
  switch (entryPoint) {
    case 'support_site':
      return DefaultTheme;
    case 'link_support_site':
      return LinkTheme;
    case 'express_support_site':
      return DefaultTheme;
    default:
      return DefaultTheme;
  }
};

export function StripeAssistantWidgetHeader({
  supportCenterHref,
  entryPoint,
}: Props) {
  const ref = useRef<HTMLDivElement | null>(null);
  const {close, open, minimize, setMinimizedHeight} = useWidgetControls();
  const {visibility} = useWidgetVisibility();
  const widget = useWidget();

  useEffect(() => {
    if (ref.current) {
      setMinimizedHeight(ref.current.offsetHeight);
    }
  }, [setMinimizedHeight]);

  return (
    <ThemeProvider value={getThemeForAudience(entryPoint)}>
      <StripeAssistantHeader
        ref={ref}
        minimized={visibility === 'minimized'}
        entryPoint={entryPoint}
        supportCenterHref={supportCenterHref}
        onMinimize={minimize}
        onOpen={open}
        onClose={close}
        onRestart={() => widget.restart()}
      />
    </ThemeProvider>
  );
}
